import ApiService from "../api";

export default class CidadeService extends ApiService {

    constructor() {
        super('/api/cidades')
    }

    listar() {
        return this.get("");
    }

    salvar(dto) {
        return this.post("", dto);
    }

    atualizar(id, dto) {
        return this.put(`/${id}`, dto);
    }

    excluir(id) {
        return this.delete(`/${id}`);
    }
}